/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Home_Sample_MoreInputs */

const ja_playdata_home_sample_more = /** @type {(inputs: Playdata_Home_Sample_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`もっと見たい方は、以下から無料サンプルレポート全体をご確認ください。`)
};

const en_playdata_home_sample_more = /** @type {(inputs: Playdata_Home_Sample_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Want to see more? See the full free sample report below.`)
};

/**
* | output |
* | --- |
* | "Want to see more? See the full free sample report below." |
*
* @param {Playdata_Home_Sample_MoreInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_home_sample_more = /** @type {((inputs?: Playdata_Home_Sample_MoreInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Home_Sample_MoreInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_home_sample_more(inputs)
	return en_playdata_home_sample_more(inputs)
});